export default __webpack_public_path__ + "static/media/gate2Klein.c6885ee1.jpg";